var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div'),_c('div'),_c('div',[_c('label',[_vm._v("订货编号：")]),_c('span')]),_c('div',[_c('label',[_vm._v("发货日期：")]),_c('span')]),_c('div',[_c('div'),_c('div')]),_c('div',[_vm._v("立即加购")])])
}]

export { render, staticRenderFns }